"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const theme_1 = require("../../theme");
const text_component_1 = require("../text/text.component");
const popover_component_1 = require("../popover/popover.component");
const nativeDate_service_1 = require("../calendar/service/nativeDate.service");
const services_1 = require("../support/services");
const type_1 = require("../popover/type");
class BaseDatepickerComponent extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.state = {
            visible: false,
        };
        this.popoverRef = react_1.default.createRef();
        this.show = () => {
            this.popoverRef.current.show();
        };
        this.hide = () => {
            this.popoverRef.current.hide();
        };
        this.focus = () => {
            this.setState({ visible: true }, this.onPickerVisible);
        };
        this.blur = () => {
            this.setState({ visible: false }, this.onPickerInvisible);
        };
        this.isFocused = () => {
            return this.state.visible;
        };
        this.getComponentStyle = (style) => {
            const { textMarginHorizontal, textFontFamily, textFontSize, textLineHeight, textFontWeight, textColor, placeholderColor, iconWidth, iconHeight, iconMarginHorizontal, iconTintColor, labelColor, labelFontSize, labelLineHeight, labelMarginBottom, labelFontWeight, captionMarginTop, captionColor, captionFontSize, captionLineHeight, captionFontWeight, captionIconWidth, captionIconHeight, captionIconMarginRight, captionIconTintColor, popoverWidth, ...controlParameters } = style;
            return {
                control: controlParameters,
                captionContainer: {
                    marginTop: captionMarginTop,
                },
                text: {
                    marginHorizontal: textMarginHorizontal,
                    fontFamily: textFontFamily,
                    fontSize: textFontSize,
                    fontWeight: textFontWeight,
                    lineHeight: textLineHeight,
                    color: textColor,
                },
                placeholder: {
                    marginHorizontal: textMarginHorizontal,
                    color: placeholderColor,
                },
                icon: {
                    width: iconWidth,
                    height: iconHeight,
                    marginHorizontal: iconMarginHorizontal,
                    tintColor: iconTintColor,
                },
                label: {
                    color: labelColor,
                    fontSize: labelFontSize,
                    lineHeight: labelLineHeight,
                    marginBottom: labelMarginBottom,
                    fontWeight: labelFontWeight,
                },
                captionIcon: {
                    width: captionIconWidth,
                    height: captionIconHeight,
                    tintColor: captionIconTintColor,
                    marginRight: captionIconMarginRight,
                },
                captionLabel: {
                    fontSize: captionFontSize,
                    fontWeight: captionFontWeight,
                    lineHeight: captionLineHeight,
                    color: captionColor,
                },
                popover: {
                    width: popoverWidth,
                    marginBottom: captionMarginTop,
                },
            };
        };
        this.onPress = (event) => {
            this.setPickerVisible();
            if (this.props.onPress) {
                this.props.onPress(event);
            }
        };
        this.onPressIn = (event) => {
            this.props.dispatch([theme_1.Interaction.ACTIVE]);
            if (this.props.onPressIn) {
                this.props.onPressIn(event);
            }
        };
        this.onPressOut = (event) => {
            this.props.dispatch([]);
            if (this.props.onPressOut) {
                this.props.onPressOut(event);
            }
        };
        this.onPickerVisible = () => {
            this.props.dispatch([theme_1.Interaction.ACTIVE]);
            if (this.props.onFocus) {
                this.props.onFocus();
            }
        };
        this.onPickerInvisible = () => {
            this.props.dispatch([]);
            if (this.props.onBlur) {
                this.props.onBlur();
            }
        };
        this.setPickerVisible = () => {
            this.setState({ visible: true }, this.onPickerVisible);
        };
        this.setPickerInvisible = () => {
            this.setState({ visible: false }, this.onPickerInvisible);
        };
        this.renderIconElement = (style) => {
            const iconElement = this.props.icon(style);
            return react_1.default.cloneElement(iconElement, {
                style: [style, iconElement.props.style],
            });
        };
        this.renderLabelElement = (style) => {
            return (react_1.default.createElement(text_component_1.Text, { key: 1, style: [style, styles.label, this.props.labelStyle] }, this.props.label));
        };
        this.renderCaptionElement = (style) => {
            return (react_1.default.createElement(text_component_1.Text, { key: 2, style: [style, styles.captionLabel, this.props.captionStyle] }, this.props.caption));
        };
        this.renderCaptionIconElement = (style) => {
            const iconElement = this.props.captionIcon(style);
            return react_1.default.cloneElement(iconElement, {
                key: 3,
                style: [style, iconElement.props.style],
            });
        };
        this.renderTextElement = (style) => {
            return (react_1.default.createElement(text_component_1.Text, { style: style, numberOfLines: 1, ellipsizeMode: 'tail' }, this.getComponentTitle()));
        };
        this.renderControlChildren = (style) => {
            return [
                this.props.icon && this.renderIconElement(style.icon),
                this.renderTextElement(style.text),
            ];
        };
        this.renderControlElement = (style) => {
            const { themedStyle, controlStyle, ...restProps } = this.props;
            const [iconElement, textElement] = this.renderControlChildren(style);
            return (react_1.default.createElement(react_native_1.TouchableOpacity, Object.assign({}, restProps, { activeOpacity: 1.0, style: [styles.control, style.control, controlStyle], onPress: this.onPress, onPressIn: this.onPressIn, onPressOut: this.onPressOut }),
                textElement,
                iconElement));
        };
        this.renderComponentChildren = (style) => {
            return [
                this.renderCalendar(),
                services_1.isValidString(this.props.label) && this.renderLabelElement(style.label),
                this.renderControlElement(style),
                services_1.isValidString(this.props.caption) && this.renderCaptionElement(style.captionLabel),
                this.props.captionIcon && this.renderCaptionIconElement(style.captionIcon),
            ];
        };
    }
    render() {
        const { themedStyle, style, placement, backdropStyle } = this.props;
        const { popover, ...componentStyle } = this.getComponentStyle(themedStyle);
        const [calendarElement, labelElement, controlElement, captionElement, captionIconElement,] = this.renderComponentChildren(componentStyle);
        return (react_1.default.createElement(react_native_1.View, { style: style },
            labelElement,
            react_1.default.createElement(popover_component_1.Popover, { ref: this.popoverRef, style: [popover, styles.popover], backdropStyle: backdropStyle, placement: placement, visible: this.state.visible, content: calendarElement, onBackdropPress: this.setPickerInvisible }, controlElement),
            react_1.default.createElement(react_native_1.View, { style: [componentStyle.captionContainer, styles.captionContainer] },
                captionIconElement,
                captionElement)));
    }
}
exports.BaseDatepickerComponent = BaseDatepickerComponent;
BaseDatepickerComponent.defaultProps = {
    dateService: new nativeDate_service_1.NativeDateService(),
    placeholder: 'dd/mm/yyyy',
    placement: type_1.PopoverPlacements.BOTTOM_START,
};
const styles = react_native_1.StyleSheet.create({
    popover: {
        borderWidth: 0,
    },
    control: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    label: {
        textAlign: 'left',
    },
    captionContainer: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    captionLabel: {
        textAlign: 'left',
    },
});
//# sourceMappingURL=baseDatepicker.component.js.map